<script lang="typescript">
  import Panel from '../../common/Panel.svelte';
  import { create } from './cancel';
  import { useMachine } from '../../common/myrobot';
  const machine = create();
  const { state, context, send } = useMachine(machine);
  const cancelMeetings = () => send('cancel');
  $:saving = $state == 'saving';
  $:disabled = saving;
  $:error = $context.error;
  $:nrCancelled = $context.nr_cancelled;
</script>

<!--
<pre>
{JSON.stringify($context, null, 2)}
</pre>
-->

<div>
  <h1>Poista umpeutuneet tapaamiset joissa ei riittävästi osallistujia</h1>
  {#if nrCancelled !== undefined}
    <p>
    Peruttuja tapaamisia {nrCancelled} kpl.
    </p>
  {/if}
  <p>
  <button on:click={cancelMeetings} {disabled}>Peru tapaamiset</button>
  </p>
  {#if saving}
    <p>
    <i class="fas fa-spinner fa-spin fa-lg"></i> Perutaan tapaamisia...
    </p>
  {/if}
  {#if error}
    <Panel type="error">
      <p>Virhe tapaamisten perumisessa.</p>
      <p>{error}</p>
      <p>
      <button on:click={cancelMeetings} {disabled}>Yritä uudelleen</button>
      </p>
    </Panel>
  {/if}
</div>

